import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// import { InferPropType } from 'vue/types/v3-component-props';
const { EleResize } = require('@/assets/js/eresize.js');
let HospitalKanban = class HospitalKanban extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.search = {
            loading: false,
            startDate: '',
            endDate: '',
            context: '',
            time: new Date().format('yyyy-MM-dd'),
            conditions: 'DATE',
            menu: {
                date: false,
                dateType: 'DATE',
                type: 'date',
                startDate: false,
                endDate: false,
            },
        };
        this.tableData = {
            headers: [
                {
                    text: '医院地区',
                    align: 'start',
                    value: 'area',
                },
                { text: '医院名称', value: 'name' },
                { text: '近一周故障数量', value: 'weekCount' },
                { text: '近一月故障数量', value: 'monthCount' },
            ],
            data: []
        };
        const that = this;
    }
    mounted() {
        this.getLayoutData();
    }
    async getLayoutData() {
        const that = this;
        try {
            that.search.loading = true;
            const params = {
                startDate: that.search.time || new Date().format('yyyy-MM-dd'),
            };
            const res = await that.axios.get('/api/report/malfunction/hospital', { params: params });
            if (!res.data || !res.data.result) {
                this.snackbar.error(`查询数据出错：${res.data.result || ''}`);
                return;
            }
            that.tableData.data = res.data.result || [];
            that.search.loading = false;
        }
        catch (error) {
            that.search.loading = false;
            this.snackbar.error(`查询数据出错：${error || ''}`);
        }
    }
    closeDatePicker() {
        const that = this;
        that.search.menu.date = false;
        that.getLayoutData();
    }
};
HospitalKanban = __decorate([
    Component({
        name: 'HospitalKanban',
        components: {
            BcSnackbar,
        }
    })
], HospitalKanban);
export default HospitalKanban;
